/* BibiJoon theme behavior — vanilla JS, no framework dependency. */
(function () {
  "use strict";

  document.documentElement.classList.add("bj-js");

  /* ---------- Header: solidify on scroll (homepage transparent-over-hero) ---------- */
  var header = document.querySelector(".bj-header");
  if (header) {
    var ticking = false;
    function updateHeaderState() {
      header.classList.toggle("bj-header--scrolled", window.scrollY > 24);
      ticking = false;
    }
    updateHeaderState();
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeaderState);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------- Scroll reveal ---------- */
  var revealTargets = document.querySelectorAll("[data-bj-reveal]");
  if ("IntersectionObserver" in window && revealTargets.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = el.hasAttribute("data-bj-reveal-stagger")
              ? parseInt(el.getAttribute("data-bj-reveal-stagger"), 10) * 80
              : 0;
            setTimeout(function () { el.classList.add("is-visible"); }, delay);
            revealObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Mobile nav drawer ---------- */
  var navToggle = document.querySelector("[data-bj-nav-toggle]");
  var navDrawer = document.querySelector("[data-bj-nav-drawer]");
  var navBackdrop = document.querySelector("[data-bj-nav-backdrop]");

  function fadeInBackdrop(el) {
    if (!el) return;
    el.removeAttribute("hidden");
    requestAnimationFrame(function () { el.classList.add("is-visible"); });
  }
  function fadeOutBackdrop(el) {
    if (!el) return;
    el.classList.remove("is-visible");
    setTimeout(function () { el.setAttribute("hidden", ""); }, 220);
  }

  function closeNav() {
    if (!navDrawer) return;
    navDrawer.setAttribute("aria-hidden", "true");
    fadeOutBackdrop(navBackdrop);
    navToggle && navToggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  function openNav() {
    if (!navDrawer) return;
    navDrawer.setAttribute("aria-hidden", "false");
    fadeInBackdrop(navBackdrop);
    navToggle && navToggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    var firstLink = navDrawer.querySelector("a, button");
    firstLink && firstLink.focus();
  }
  if (navToggle && navDrawer) {
    navToggle.addEventListener("click", function () {
      var isOpen = navToggle.getAttribute("aria-expanded") === "true";
      isOpen ? closeNav() : openNav();
    });
    navBackdrop && navBackdrop.addEventListener("click", closeNav);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeNav();
    });
  }

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  var stickyBar = document.querySelector("[data-bj-sticky-atc]");
  var atcAnchor = document.querySelector("[data-bj-atc-anchor]");
  if (stickyBar && atcAnchor && "IntersectionObserver" in window) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle("is-visible", !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    atcObserver.observe(atcAnchor);
  }

  /* ---------- Variant price / availability sync (PDP) ---------- */
  var variantSelect = document.querySelector("[data-bj-variant-select]");
  if (variantSelect) {
    variantSelect.addEventListener("change", function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      var price = option.getAttribute("data-price");
      var available = option.getAttribute("data-available") === "true";
      var priceEls = document.querySelectorAll("[data-bj-current-price]");
      priceEls.forEach(function (el) { if (price) el.textContent = price; });
      var atcButtons = document.querySelectorAll("[data-bj-add-to-cart]");
      atcButtons.forEach(function (btn) {
        btn.disabled = !available;
        btn.textContent = available ? btn.getAttribute("data-label-available") : btn.getAttribute("data-label-sold-out");
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll("[data-bj-qty]").forEach(function (wrapper) {
    var input = wrapper.querySelector("input");
    wrapper.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = parseInt(btn.getAttribute("data-step"), 10);
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---------- Add to cart (Shopify AJAX Cart API) ---------- */
  document.querySelectorAll("[data-bj-add-to-cart-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector("[data-bj-add-to-cart]");
      var originalLabel = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = form.getAttribute("data-label-adding") || "Adding…";

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: form.querySelector('[name="id"]').value,
              quantity: parseInt(form.querySelector('[name="quantity"]').value || "1", 10),
            },
          ],
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart/add failed");
          return res.json();
        })
        .then(function () {
          submitBtn.textContent = form.getAttribute("data-label-added") || "Added";
          document.dispatchEvent(new CustomEvent("bibijoon:cart:add"));
          setTimeout(function () {
            submitBtn.textContent = originalLabel;
            submitBtn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          submitBtn.textContent = "Couldn't add — retry";
          submitBtn.disabled = false;
        });
    });
  });

  /* ---------- Accordion (PDP + ingredient-trust FAQ) ---------- */
  document.querySelectorAll("[data-bj-accordion-trigger]").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var isOpen = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");
    });
  });

  /* ---------- Header dropdown (click-toggle for touch; CSS handles hover/focus) ---------- */
  document.querySelectorAll("[data-bj-dropdown]").forEach(function (dropdown) {
    var toggle = dropdown.querySelector("[data-bj-dropdown-toggle]");
    if (!toggle) return;
    toggle.addEventListener("click", function () {
      var isOpen = dropdown.getAttribute("data-open") === "true";
      document.querySelectorAll("[data-bj-dropdown]").forEach(function (d) {
        d.setAttribute("data-open", "false");
        d.querySelector("[data-bj-dropdown-toggle]").setAttribute("aria-expanded", "false");
      });
      dropdown.setAttribute("data-open", isOpen ? "false" : "true");
      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
    });
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-bj-dropdown]")) {
      document.querySelectorAll("[data-bj-dropdown]").forEach(function (d) {
        d.setAttribute("data-open", "false");
        d.querySelector("[data-bj-dropdown-toggle]").setAttribute("aria-expanded", "false");
      });
    }
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector("[data-bj-cart-drawer]");
  var cartBackdrop = document.querySelector("[data-bj-cart-backdrop]");
  var cartToggles = document.querySelectorAll("[data-bj-cart-toggle]");

  function moneyFormat(cents) {
    return "Rs. " + (cents / 100).toLocaleString("en-PK", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("aria-hidden", "true");
    fadeOutBackdrop(cartBackdrop);
    document.body.style.overflow = "";
  }
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("aria-hidden", "false");
    fadeInBackdrop(cartBackdrop);
    document.body.style.overflow = "hidden";
    var closeBtn = cartDrawer.querySelector("[data-bj-cart-close]");
    closeBtn && closeBtn.focus();
  }
  if (cartDrawer) {
    cartToggles.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
      });
    });
    cartDrawer.querySelectorAll("[data-bj-cart-close]").forEach(function (btn) {
      btn.addEventListener("click", closeCart);
    });
    cartBackdrop && cartBackdrop.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCart();
    });

    function renderCart(cart) {
      var countEls = document.querySelectorAll("[data-bj-cart-count]");
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      var body = cartDrawer.querySelector("[data-bj-cart-body]");
      var titleEl = cartDrawer.querySelector(".bj-cart-drawer__title");
      if (titleEl) titleEl.textContent = "Your Bag" + (cart.item_count > 0 ? " (" + cart.item_count + ")" : "");
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="bj-cart-drawer__empty" data-bj-cart-empty>' +
          '<p class="bj-title">Your bag is empty</p>' +
          '<p class="bj-body bj-cart-drawer__empty-copy">Skincare that’s actually formulated for your skin is one click away.</p>' +
          '<a href="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.all_products_collection_url : "/collections/all") + '" class="bj-btn bj-btn--primary" data-bj-cart-close>Shop the Edit</a>' +
          "</div>";
        var footer = cartDrawer.querySelector("[data-bj-cart-footer]");
        footer && footer.remove();
        body.querySelectorAll("[data-bj-cart-close]").forEach(function (btn) { btn.addEventListener("click", closeCart); });
        return;
      }

      var itemsHtml = cart.items
        .map(function (item, i) {
          var line = i + 1;
          var variantHtml =
            item.variant_title && item.variant_title !== "Default Title"
              ? '<p class="bj-cart-item__variant">' + item.variant_title + "</p>"
              : "";
          var img = item.image ? '<img src="' + item.image + '" alt="" width="100" height="125" loading="lazy">' : "";
          return (
            '<li class="bj-cart-item" data-bj-cart-line="' + line + '">' +
            '<a href="' + item.url + '" class="bj-cart-item__media">' + img + "</a>" +
            '<div class="bj-cart-item__info">' +
            '<a href="' + item.url + '" class="bj-title bj-cart-item__title">' + item.product_title + "</a>" +
            variantHtml +
            '<p class="bj-cart-item__price">' + moneyFormat(item.final_line_price / item.quantity) + "</p>" +
            '<div class="bj-cart-item__row">' +
            '<div class="bj-qty bj-qty--sm" data-bj-cart-qty data-line="' + line + '">' +
            '<button type="button" data-step="-1" aria-label="Decrease quantity">–</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity for ' + item.product_title + '">' +
            '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
            "</div>" +
            '<button type="button" class="bj-cart-item__remove" data-bj-cart-remove data-line="' + line + '" aria-label="Remove ' + item.product_title + '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m2 0-1 13a1 1 0 01-1 1H8a1 1 0 01-1-1L6 7h12z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            "</button>" +
            "</div></div></li>"
          );
        })
        .join("");
      body.innerHTML = '<ul class="bj-cart-drawer__items" data-bj-cart-items>' + itemsHtml + "</ul>";
      var itemsList = body.querySelector("[data-bj-cart-items]");
      if (itemsList) requestAnimationFrame(function () { itemsList.classList.add("is-visible"); });

      var footer = cartDrawer.querySelector("[data-bj-cart-footer]");
      if (!footer) {
        // First item added this session — the footer only exists server-side
        // when the cart already had items, so build it once here.
        var cartUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_url : "/cart";
        var allProductsUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.all_products_collection_url : "/collections/all";
        footer = document.createElement("div");
        footer.className = "bj-cart-drawer__footer";
        footer.setAttribute("data-bj-cart-footer", "");
        footer.innerHTML =
          '<div class="bj-cart-drawer__subtotal"><span class="bj-title">Subtotal</span><span class="bj-title" data-bj-cart-subtotal></span></div>' +
          '<p class="bj-cart-drawer__note">Shipping, taxes, and discounts calculated at checkout.</p>' +
          '<form action="' + cartUrl + '" method="post" novalidate>' +
          '<button type="submit" name="checkout" class="bj-btn bj-btn--primary bj-cart-drawer__checkout">Checkout</button>' +
          "</form>" +
          '<a href="' + allProductsUrl + '" class="bj-btn bj-btn--ghost bj-cart-drawer__continue" data-bj-cart-close>Continue Shopping</a>';
        cartDrawer.appendChild(footer);
        footer.querySelectorAll("[data-bj-cart-close]").forEach(function (btn) { btn.addEventListener("click", closeCart); });
      }
      var subtotalEl = footer.querySelector("[data-bj-cart-subtotal]");
      subtotalEl && (subtotalEl.textContent = moneyFormat(cart.total_price));

      bindCartLineEvents();
    }

    function updateLine(line, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(renderCart)
        .catch(function () { /* leave state as-is on failure */ });
    }

    function bindCartLineEvents() {
      cartDrawer.querySelectorAll("[data-bj-cart-qty]").forEach(function (wrapper) {
        var input = wrapper.querySelector("input");
        var line = wrapper.getAttribute("data-line");
        wrapper.querySelectorAll("button").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var step = parseInt(btn.getAttribute("data-step"), 10);
            var next = Math.max(0, (parseInt(input.value, 10) || 1) + step);
            updateLine(line, next);
          });
        });
      });
      cartDrawer.querySelectorAll("[data-bj-cart-remove]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          updateLine(btn.getAttribute("data-line"), 0);
        });
      });
    }
    bindCartLineEvents();

    document.addEventListener("bibijoon:cart:add", function () {
      fetch("/cart.js")
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCart(cart);
          openCart();
        })
        .catch(function () { openCart(); });
    });
  }

  /* ---------- Skincare Journal: article table of contents (auto-generated from H2/H3s) ---------- */
  var articleBody = document.querySelector("[data-bj-article-body]");
  var tocNav = document.querySelector("[data-bj-toc]");
  if (articleBody && tocNav) {
    var headings = articleBody.querySelectorAll("h2, h3");
    if (headings.length >= 3) {
      var tocList = tocNav.querySelector("[data-bj-toc-list]");
      headings.forEach(function (heading, i) {
        if (!heading.id) heading.id = "section-" + (i + 1);
        var item = document.createElement("li");
        if (heading.tagName === "H3") item.style.marginLeft = "1em";
        var link = document.createElement("a");
        link.href = "#" + heading.id;
        link.textContent = heading.textContent;
        item.appendChild(link);
        tocList.appendChild(item);
      });
      tocNav.hidden = false;
    }
  }

  /* ---------- Skincare Journal: share row copy-link ---------- */
  document.querySelectorAll("[data-bj-copy-link]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var url = btn.getAttribute("data-bj-copy-link");
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(function () {
        var original = btn.getAttribute("aria-label");
        btn.setAttribute("aria-label", "Link copied");
        setTimeout(function () { btn.setAttribute("aria-label", original); }, 1500);
      });
    });
  });
})();
